import DataLayer from "./DataLayer";
import { getModel } from "core-web/state";

export default (data) => {
    if (!data?.product) {
        return;
    }

    const application = getModel("application");

    DataLayer.track({
        event: "product_click",
        ecommerce: {
            click: {
                // actionField: { list: data.list },
                products: [DataLayer.getImpression(data.product)],
            },
        },
        currency: application.currency.code,
    });
};
